import { WORKER_TYPES } from "../types";
import { WorkerService } from "../../services";

export const SaveWorkerRegisterForm = (newWorker, setSubmitting,setProcessStatus) => async (
  dispatch
) => {
  setSubmitting(true);
  setProcessStatus(false);
  try {
  
    const response = await WorkerService.SEND_REGISTER_FORM(newWorker);
    const { success, message } = await response.data;
    if (success) {
      dispatch({ type: WORKER_TYPES.PROCESS_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: WORKER_TYPES.PROCESS_FAIL, payload: message });
    }
    setSubmitting(false);
    setProcessStatus(true);
  } catch (error) {
    const { message, response } = error;
    if (response) {
      const { data } = response;
      if (data) {
        const rd =JSON.stringify(data);
        dispatch({ type: WORKER_TYPES.PROCESS_FAIL, payload: rd });
      }
    } else {
      dispatch({ type: WORKER_TYPES.PROCESS_FAIL, payload: message });
    }
    setSubmitting(false);
    setProcessStatus(true);
  }

};

export const UpdateWorkerRegisterForm = (
  workerId,
  registeredBefore,
  newWorker,
  setSubmitting,setProcessStatus
) => async (dispatch) => {
  try {
    setSubmitting(true);
    setProcessStatus(false);
    const response = await WorkerService.UPDATE_WORKER_REGISTER_FORM(
      workerId,
      newWorker
    );
    const { success, message } = await response.data;
    if (!success) {
      dispatch({ type: WORKER_TYPES.PROCESS_FAIL, payload: message });
    } else {
      if (!registeredBefore && newWorker.baseFields.isRegistered) {
        const responseReg = await WorkerService.REGISTER_WORKER(workerId);
        const successReg = await responseReg.data.success;
        const messageReg = await responseReg.data.message;
        if (successReg) {
          dispatch({ type: WORKER_TYPES.PROCESS_SUCCESS });
        } else {
          dispatch({ type: WORKER_TYPES.PROCESS_FAIL, payload: messageReg });
        }
      } else {
        dispatch({ type: WORKER_TYPES.PROCESS_SUCCESS });
      }
    }
    setSubmitting(false);
    setProcessStatus(true);
  } catch (error) {
    const { message, response } = error;
    if (response) {
      const { data } = response;
      if (data) {
        const rd =JSON.stringify(data);
        dispatch({ type: WORKER_TYPES.PROCESS_FAIL, payload: rd });
      }
    } else {
      dispatch({ type: WORKER_TYPES.PROCESS_FAIL, payload: message });
    }
    setSubmitting(false);
    setProcessStatus(true);
  }
};
